interface Props {
    angleStart: number
    angleEnd: number
    color: string
    icon: string
    onClick: (e: any) => void
}

const PieChartPart = (props: Props) => {
    const { color, angleStart, angleEnd, icon, onClick } = props

    const defaultStyle = { display: 'none', backgroundColor: color, transform: 'rotate(0deg), skew(0deg)'}
    let segmentA = {...defaultStyle}
    let segmentB = {...defaultStyle}
    let segmentC = {...defaultStyle}
    let segmentD = {...defaultStyle}
    let borderSegment = {...defaultStyle}
    
    if(angleEnd - angleStart >= 0) {
        segmentA['display'] = 'block'
        const skew = 90 - Math.min(90, angleEnd - angleStart)
        segmentA['transform'] = `rotate(${angleStart}deg) skew(${skew}deg)`
    }
    if(angleEnd - angleStart >= 90) {
        segmentB['display'] = 'block'
        const skew = 90 - Math.min(90, angleEnd - angleStart - 90)
        segmentB['transform'] = `rotate(${angleStart + 90}deg) skew(${skew}deg)`
    }
    if(angleEnd - angleStart >= 180) {
        segmentC['display'] = 'block'
        const skew = 90 - Math.min(90, angleEnd - angleStart - 180)
        segmentC['transform'] = `rotate(${angleStart + 180}deg) skew(${skew}deg)`
    }
    if(angleEnd - angleStart >= 270) {
        segmentD['display'] = 'block'
        const skew = 90 - Math.min(90, angleEnd - angleStart - 270)
        segmentD['transform'] = `rotate(${angleStart + 270}deg) skew(${skew}deg)`
    }
    const borderAngle = 1.5

    borderSegment['display'] = 'block'
    borderSegment['transform'] = `rotate(${angleStart}deg) skew(${90 - borderAngle}deg)`
    borderSegment['backgroundColor'] = '#ffffff'

    const iconStyle = {
        color: "#fff",
        display: 'block',//(angleEnd - angleStart >= 10) ? 'block' : 'none',
        fontSize: (angleEnd - angleStart >= 10) ? '25px' : '15px',
        transform: `rotate(${(angleStart + angleEnd + borderAngle ) / 2}deg) translate(${262}px) rotate(-${(angleStart + angleEnd ) / 2}deg)`
    }

    return <div className='pie-chart-part'>
        <div className='segment' style={segmentA} onClick={onClick}/>
        <div className='segment' style={segmentB} onClick={onClick}/>
        <div className='segment' style={segmentC} onClick={onClick}/>
        <div className='segment' style={segmentD} onClick={onClick}/>
        <div className='segment' style={borderSegment}/>
        <div
        className={`icon fa-solid fa-${icon || 'question'}`}
        style={iconStyle} onClick={onClick}/>
    </div>
}

export default PieChartPart